export default __webpack_public_path__ + "static/media/home-2.abf5c96d.jpg";